import { render, staticRenderFns } from "./EventCommentListComponent.vue?vue&type=template&id=4c4aedbf&scoped=true"
import script from "./EventCommentListComponent.vue?vue&type=script&lang=js"
export * from "./EventCommentListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4aedbf",
  null
  
)

export default component.exports